import { render } from "./SoldProducts.vue?vue&type=template&id=73face14"
import script from "./SoldProducts.vue?vue&type=script&lang=js"
export * from "./SoldProducts.vue?vue&type=script&lang=js"

import "./SoldProducts.vue?vue&type=style&index=0&id=73face14&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__